import { render, staticRenderFns } from "./Institucija.vue?vue&type=template&id=25e9dd72&"
import script from "./Institucija.vue?vue&type=script&lang=js&"
export * from "./Institucija.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports